const OFFICE_HOURS = {
  OFFICE_HEADER_TITLE: 'Working hours',
  OFFICE_HEADER_DESC:
    'Specify your working hours so that users know your working hours. Other than these times, these are your non-working times. Do not lose even a single user during non-working times. (being online in Telegram does not mean being online)',
  OFFICE_SECTION_TITLE: 'Working hours',
  ADD_OFFICE_HOURS_BTN: 'Add working time',
  NON_OFFICE_HOURS_TITLE: 'Non-working hours',
  EMPTY_OFFICE_HOURS_TEXT:
    'If you have not defined working hours, the whole week will be considered as your working hours and the settings of non-working hours will not be applied.',

  TIME_OPTION_WORK_DAY: 'Work Days',
  TIME_OPTION_WHOLE_WEEK: 'Whole Week',
  TIME_OPTION_SATURDAY: 'Saturday',
  TIME_OPTION_SUNDAY: 'Sunday',
  TIME_OPTION_MONDAY: 'Monday',
  TIME_OPTION_TUESDAY: 'Tuesday',
  TIME_OPTION_WEDNESDAY: 'Wednesday',
  TIME_OPTION_THURSDAY: 'Thursday',
  TIME_OPTION_FRIDAY: 'Friday',

  NON_OFFICE_OFFLINE_TITLE:
    'Offline message and get user information to access again',
  NON_OFFICE_OFFLINE_GUIDE:
    'If the user is answered, the user will be notified via email.',
  NON_OFFICE_ONLINE_TITLE: 'Switch to online mode when using chat applications',
  NON_OFFICE_ONLINE_GUIDE:
    'If you are online in the web, mobile and desktop application, the status of operators will be displayed online for users.',
  NON_OFFICE_AUTO_MSG_TITLE:
    'Do not send smart messages during non-working hours',
  NON_OFFICE_AUTO_MSG_GUIDE:
    'Do not send smart messages during non-working hours',
  NON_OFFICE_TELEGRAM_TITLE: 'Send messages to Telegram',
  NON_OFFICE_TELEGRAM_GUIDE:
    'The messages are sent to Telegram operators, but your status is still offline.',
  NON_OFFICE_SLEEP_TITLE: 'Changing the widget icon to sleep mode',
  NON_OFFICE_SLEEP_GUIDE:
    'In case of being offline, the appearance of the widget icon changes to sleep mode.',
  NON_OFFICE_HIDDEN_TITLE: 'Hide the widget',
  NON_OFFICE_DISABLE_CHAT: 'Disable Chat',
  NON_OFFICE_DISABLE_CHAT_GUIDE:
    'Disabling the ability to send messages during non-working hours',
  NON_OFFICE_HIDDEN_GUIDE:
    'The widget is not displayed during non-working hours.',
  OFFICE_TIME_NOT_SELECTED_ERROR: 'Select day',
  OFFLINE_MSG_SETTINGS_SUBMIT: 'Save',
  OFFLINE_MSG_SETTINGS_CANCEL: 'Cancel',

  WORK_TIME_FROM_LABEL: 'From',
  WORK_TIME_TO_LABEL: 'To',
};

export default OFFICE_HOURS;
